// extracted by mini-css-extract-plugin
module.exports = {"recaptcha":"_8fc97e3","recaptchaError":"_3d9462c"};